import { Toast } from 'primereact/toast'
import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS, { DEFAULT_DISCOUNT } from '../../helperFunction/Constant'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup";
import { Link, useNavigate, useParams } from 'react-router-dom'

const AddAffiliate = () => {

    const toast = useRef(null)
    const [affiliateData, setAffiliateData] = useState([])

    const affiliateCodeTimer = useRef(null);

    const navigate = useNavigate()

    const { id } = useParams()

    const isEdit = id ? true : false
    
    const schema = yup.object({
        affiliateCode: yup.string().notRequired(),
        fullName: yup.string().trim().required("Full Name is required"),
        mobileNumber: yup.string().required("Mobile Number is required").matches(/^[6-9]\d{9}$/, "Enter a valid mobile number"),
        email: yup.string().email("Enter a valid email").required("Business Email is required"),
        companyName: yup.string().trim().nullable().notRequired(),
        websiteOrSocialProfile: yup.string().nullable().notRequired(),
        commissionPercentage: yup.number().nullable().notRequired().min(0, "Minimum commission is 0%").max(90, "Maximum commission is 90%"),
        panNumber: yup.string().nullable().notRequired(),
        gstNumber: yup.string().nullable().notRequired(),
        paymentMethod: yup.string().oneOf(["upi", "bank"]).required("Payment Method is required"),
        upiId: yup.string().when("paymentMethod", { is: "upi", then: (schema) => schema.required("UPI ID is required").matches(/^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/,"Invalid UPI ID"), otherwise: (schema) => schema.notRequired(), }),
        accountHolderName: yup.string().when("paymentMethod", { is: "bank", then: (schema) => schema.required("Account Holder Name is required"), otherwise: (schema) => schema.notRequired(), }),
        bankName: yup.string().when("paymentMethod", {is: "bank",then: (schema) => schema.required("Bank Name is required"),otherwise: (schema) => schema.notRequired(),}),
        accountNumber: yup.string().when("paymentMethod", {is: "bank",then: (schema) => schema.required("Account Number is required"),otherwise: (schema) => schema.notRequired(),}),
        ifscCode: yup.string().when("paymentMethod", {is: "bank", then: (schema) => schema.required("IFSC Code is required").matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code"), otherwise: (schema) => schema.notRequired(),}),
        cancelledCheque: yup.mixed().when("paymentMethod", {is: "bank", then: (schema) => schema.test("required","Cancelled Cheque is required",(value) => value && value.length > 0), otherwise: (schema) => schema.notRequired(), }),
        isActive: yup.boolean().notRequired(),
    });

    
    const { register, handleSubmit, reset, watch, setValue, setError, clearErrors, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });
    
    const affiliateCodeRegister = register("affiliateCode");

    useEffect(() => {
        isEdit && getAffiliates()
    }, [])
    
    const getAffiliates = async () => {
        await ApiHelper.get(`${API_ENDPOINTS.AFFILIATES}/${id}`).then((res) => {
        // console.log('res: ', res);
            if (res.status === 200) {
                setAffiliateData(res.data.data)
                reset({
                    affiliateCode: res.data.data.affiliateCode,
                    fullName: res.data.data.fullName,
                    email: res.data.data.email,
                    mobileNumber: res.data.data.mobileNumber,
                    companyName: res.data.data.companyName,
                    websiteOrSocialProfile: res.data.data.websiteOrSocialProfile,
                    panNumber: res.data.data.panNumber,
                    gstNumber: res.data.data.gstNumber,
                    paymentMethod: res.data.data.paymentMethod,
                    upiId: res.data.data.upiId,
                    accountHolderName: res.data.data.accountHolderName,
                    bankName: res.data.data.bankName,
                    accountNumber: res.data.data.accountNumber,
                    ifscCode: res.data.data.ifscCode,
                    cancelledCheque: res.data.data.cancelledCheque,
                    isActive: res.data.data.isActive,
                });
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const generateAffiliateCode = (e) => {
        const currentAffiliateCode = watch("affiliateCode");
        if (currentAffiliateCode) return;
        const fullName = e.target.value.trim();
        if (!fullName) return;
        const firstName = fullName.split(" ")[0].toUpperCase();
        const code = `${firstName}${DEFAULT_DISCOUNT}`;
        setValue("affiliateCode", code);
        checkAffiliateCode(code ? code : currentAffiliateCode)
    };

    const handleAffiliateCodeChange = (value) => {
        if (affiliateData?.affiliateCode === value) return;
        clearTimeout(affiliateCodeTimer.current);
        affiliateCodeTimer.current = setTimeout(() => { checkAffiliateCode(value); }, 500);
    };

    const onSubmit = (data) => {
        const formData = new FormData();
        if (data?.affiliateCode) formData.append("affiliateCode", data?.affiliateCode.toUpperCase());
        formData.append("fullName", data?.fullName);
        formData.append("mobileNumber", data?.mobileNumber);
        formData.append("email", data?.email);
        formData.append("companyName", data?.companyName);
        formData.append("websiteOrSocialProfile", data?.websiteOrSocialProfile);
        formData.append("commissionPercentage", DEFAULT_DISCOUNT);
        formData.append("panNumber", data?.panNumber);
        formData.append("gstNumber", data?.gstNumber);
        formData.append("paymentMethod", data?.paymentMethod);
        formData.append("isActive", data?.isActive);
        if (data?.paymentMethod === "upi") formData.append("upiId", data?.upiId);
        if (data?.paymentMethod === "bank") {
            formData.append("accountHolderName", data?.accountHolderName);
            formData.append("bankName", data?.bankName);
            formData.append("accountNumber", data?.accountNumber);
            formData.append("ifscCode", data?.ifscCode);
            if (data?.cancelledCheque?.[0]) formData.append("cancelledCheque", data?.cancelledCheque[0]);
        }
        if (isEdit) {
            update(formData)
        } else {
            add(formData)
        }
    }

    const checkAffiliateCode = async (data) => {
        const obj = { affiliateCode: data }
        await ApiHelper.post(`${API_ENDPOINTS.AFFILIATES}/check-code`, obj).then((res) => {
            if (res.status === 200) {
                if (res?.data?.exists) {
                    setError("affiliateCode", { type: "server", message: "Code already exists." });
                } else{
                    clearErrors("affiliateCode");
                }
            }
        }).catch((error) => {
            console.log("error: ", error);
        })
    };
    
    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.AFFILIATES}/add`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/affiliates')
                }, 900)
            }
        }).catch((error) => {
            const message = error?.response?.data?.message;
            const errorMap = { "Mobile number already exists.": "mobileNumber", "Email already exists.": "email", "Affiliate Code already Existed": 'affiliateCode' };
            const field = errorMap[message];
            if (field) {
                setError(field, { type: "server", message: message });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message || "Something went wrong", life: 3000 })
            }
        })
    };
    
    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.AFFILIATES}/update/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/affiliates')
                }, 900)
            }
        }).catch((error) => {
            const message = error?.response?.data?.message;
            const errorMap = { "Mobile number already exists.": "mobileNumber", "Email already exists.": "email" };
            const field = errorMap[message];
            if (field) {
                setError(field, { type: "server", message: message });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message || "Something went wrong", life: 3000 })
            }
        })
    };

  return (
    <>
        <Toast ref={toast} />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2">
                            <span class="d-flex text-muted fw-light">
                                <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/affiliates')}> Affiliates </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                            </span>
                        </h4>
                        <Link to="/affiliates" class="btn btn-secondary">⬅ Go Back </Link>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="row">

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Full Name</label>
                                                <input className="form-control" {...register("fullName")} onBlur={generateAffiliateCode} placeholder='Full Name'/>
                                                <small className="text-danger">{errors.fullName?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Email</label>
                                                <input className="form-control" {...register("email")} placeholder='Email'/>
                                                <small className="text-danger">{errors.email?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Mobile Number</label>
                                                <input className="form-control" {...register("mobileNumber")} placeholder='Mobile Number'/>
                                                <small className="text-danger">{errors.mobileNumber?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Company Name (Optional)</label>
                                                <input className="form-control" {...register("companyName")} placeholder='Company Name'/>
                                                <small className="text-danger">{errors.companyName?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Website / Social Profile (Optional)</label>
                                                <input className="form-control" {...register("websiteOrSocialProfile")} placeholder='Website / Social Profile'/>
                                                <small className="text-danger">{errors.websiteOrSocialProfile?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">PAN Number (Optional)</label>
                                                <input className="form-control" {...register("panNumber")} placeholder='PAN Number'/>
                                                <small className="text-danger">{errors.panNumber?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">GST Number (Optional)</label>
                                                <input className="form-control" {...register("gstNumber")} placeholder='GST Number'/>
                                                <small className="text-danger">{errors.gstNumber?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Commission Percentage</label>
                                                <input className="form-control" {...register("commissionPercentage")} defaultValue={DEFAULT_DISCOUNT}/>
                                                <small className="text-danger">{errors.commissionPercentage?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Affiliate Code</label>
                                                <input className="form-control" {...affiliateCodeRegister} onChange={(e) => {
                                                    const value = e.target.value.toUpperCase();
                                                    affiliateCodeRegister.onChange({ ...e, target: { ...e.target, value: value.toUpperCase() } });
                                                    handleAffiliateCodeChange(value.toUpperCase()); }} placeholder='Code'
                                                />
                                                <small className="text-danger">{errors.affiliateCode?.message}</small>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Payment Method</label>
                                                <select className="form-select" defaultValue={affiliateData?.paymentMethod} {...register("paymentMethod")}>
                                                    <option value="">Select Payment Method</option>
                                                    <option value="upi">UPI</option>
                                                    <option value="bank">Bank</option>
                                                </select>
                                                <small className="text-danger">{errors.paymentMethod?.message}</small>
                                            </div>

                                            {watch("paymentMethod") === "upi" && (
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">UPI ID</label>
                                                    <input className="form-control" {...register("upiId")} placeholder='UPI ID' />
                                                    <small className="text-danger">{errors.upiId?.message}</small>
                                                </div>
                                            )}

                                            {watch("paymentMethod") === "bank" && (
                                                <>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label">Account Holder Name</label>
                                                        <input className="form-control" {...register("accountHolderName")} placeholder='Account Holder Name'/>
                                                        <small className="text-danger">{errors.accountHolderName?.message}</small>
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label">Bank Name</label>
                                                        <input className="form-control" {...register("bankName")} placeholder='Bank Name'/>
                                                        <small className="text-danger">{errors.bankName?.message}</small>
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label">Account Number</label>
                                                        <input className="form-control" {...register("accountNumber")} placeholder='Account Number'/>
                                                        <small className="text-danger">{errors.accountNumber?.message}</small>
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label">IFSC Code</label>
                                                        <input className="form-control" {...register("ifscCode")} placeholder='IFSC Code'/>
                                                        <small className="text-danger">{errors.ifscCode?.message}</small>
                                                    </div>
                                                    
                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label">Cancelled Cheque</label>
                                                        <br />
                                                        <input type='file' className="form-control" {...register("cancelledCheque")}/>
                                                        {affiliateData.cancelledCheque && (
                                                            <Link to={affiliateData.cancelledCheque} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm" > View Document </Link>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                            
                                            <div class="col-md-3">
                                                <label class="form-label">Active</label>
                                                <div class="form-check form-switch mb-2">
                                                    <input class="form-check-input mt-2" defaultChecked type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                </div>
                                            </div>

                                            <div className="col-md-12 text-end mt-3">
                                                <button type="submit" disabled={errors?.affiliateCode ? true : false} className="btn btn-primary"> { isEdit ? 'Update' : 'Add' } </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout> 
    </>
  )
}

export default AddAffiliate
